export enum ImageTypeEnumPersian {
  Photo = "عکس",
  Vector = "وکتور",
  Illustration = "طرح",
}
